/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Your_Recovery_CodeInputs */



/**
* | output |
* | --- |
* | "Your Recovery Code" |
*
* @param {Auth_Your_Recovery_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_your_recovery_code = /** @type {((inputs?: Auth_Your_Recovery_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Your_Recovery_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein Wiederherstellungscode")
	return /** @type {LocalizedString} */ ("Your Recovery Code")
});